<template>
  <div>
    <ul class="vs-list">
      <li
        v-for="(file, index) of fileMeta"
        :key="index"
        class="vs-list_item"
      >
        <span class="file-list_item_name">{{ file.name }}</span>
        <span class="file-list_item_size">{{ file.size | fileSize }}</span>
        <div class="list-control">
          <button
            v-if="uploadingStatus === 'init'"
            class="file-list_item_delete-button button white-button is-small"
            @click="removeFile(index)"
          >
            <i
              class="icon-cancel"
              aria-hidden="true"
            />
          </button>
          <i
            v-if="uploadingFilesProgress[index] === 100"
            class="icon-check circle-icon icon_done"
            aria-hidden="true"
          />
        </div>
      </li>
    </ul>
    <div class="panel-footer has-text-centered">
      <div v-if="uploadingStatus === 'init'">
        <button
          class="button panel-footer_button"
          @click="cancelUpload"
        >
          Cancel
        </button>
        <button
          class="button panel-footer_button is-primary"
          @click="uploadFiles"
        >
          Upload
        </button>
      </div>
      <ProgressPanel
        v-else
        :uploadingStatus="uploadingStatus"
        @close="cancelUpload"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import ProgressPanel from './ProgressPanel'

export default {
  components: {
    ProgressPanel
  },
  props: {
    selectedFiles: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      uploadingStatus: 'init'
    }
  },
  computed: {
    ...mapGetters({
      uploadingFilesProgress: 'datalink/uploadingFilesProgress'
    }),
    fileMeta () {
      return this.selectedFiles.map(file => {
        let newFileInfo = {
          name: file.name,
          size: file.size,
          type: file.type
        }
        return newFileInfo
      })
    }
  },
  created () {
    this.resetUploadFilesStatus()
  },
  methods: {
    ...mapActions('datalink', [
      'uploadFilesToS3'
    ]),
    ...mapMutations('datalink', [
      'resetUploadFilesStatus'
    ]),
    async uploadFiles () {
      try {
        this.uploadingStatus = 'uploading'
        await this.uploadFilesToS3({
          files: this.selectedFiles,
          fileMeta: this.fileMeta
        })
        this.uploadingStatus = 'uploaded'
      } catch (e) {
        this.uploadingStatus = 'doneWithError'
        this.cancelUpload()
        this.$toast.open({
          message: 'An error has occurred please try again',
          type: 'is-danger'
        })
      }
    },
    removeFile (index) {
      this.$emit('removeFile', index)
    },
    cancelUpload () {
      this.$emit('cancelUpload')
    }
  }
}
</script>

<style scoped lang="scss">
.vs-list {
  max-height: 130px;
  overflow-y: auto;
  font-size: 10px;
  background-color: $white;

  .vs-list_item {
    display: flex;
    padding: 10px;
    border-bottom: 1px solid $gray-300;
  }

  .file-list_item_name {
    width: 50%;
  }

  .list-control {
    margin-left: auto;
  }

  .file-list_item_delete-button {
    color: $gray-500;
  }
}

.panel-footer {
  padding: 40px;

  .panel-footer_button {
    width: 225px;
  }

  .panel-footer_button:first-child {
    margin-right: 20px;
  }
}

.icon_done {
  margin-left: 5px;
  color: white;
  background-color: $primary;
}
</style>
